import { ToggleComponent } from './toggle.component';

export default angular
  .module('sfMobile.components.toggle', [])
  .component('sfToggle', ToggleComponent).name;
